import { Link } from "react-router-dom";
import "./Landing.css";

export default function Kvkk() {
  return (
    <div className="lx-root">
      <main className="lx-legal" data-testid="page-kvkk">
        <h1>KVKK Aydınlatma Metni</h1>
        <p className="lx-meta">Son güncelleme: 11 Şubat 2026</p>

        <h2>1. Veri Sorumlusu</h2>
        <p>
          Terminal-EX platformu (bundan sonra “Platform”) kişisel verilerin
          işlenmesinde 6698 sayılı Kişisel Verilerin Korunması Kanunu’na uygun
          hareket eder. Yetkili: <strong>@paranoya</strong> (Telegram).
        </p>

        <h2>2. İşlenen Veriler</h2>
        <ul>
          <li>Telegram kullanıcı adı ve <code>chat_id</code></li>
          <li>Hesap oluşturma tarihi ve son oturum açma zamanı</li>
          <li>Şifrelenmiş JWT oturum bilgileri</li>
          <li>Borsa API anahtarları (yalnızca kullanıcı cihazındaki yerel
              depolama ve sunucuda şifreli kayıt; <em>çekim yetkisi içermez</em>)</li>
          <li>Açılan pozisyonlar, sinyal yanıtları ve işlem geçmişi</li>
        </ul>

        <h2>3. İşleme Amaçları</h2>
        <ul>
          <li>Kullanıcı kimlik doğrulama (Telegram OTP)</li>
          <li>Hizmet sunumu ve işlem yürütme</li>
          <li>Yasal yükümlülüklerin karşılanması</li>
          <li>Sistem güvenliği ve kötüye kullanım tespiti</li>
        </ul>

        <h2>4. Aktarım</h2>
        <p>
          Veriler üçüncü kişilere satılmaz. Yalnızca işlemlerin yürütülmesi
          için zorunlu olan üçüncü taraf borsalara (Darkex, Binance) ve
          Telegram’a iletilir.
        </p>

        <h2>5. Haklarınız</h2>
        <p>
          KVKK madde 11 kapsamında bilgi alma, düzeltme, silme ve itiraz
          haklarınız bulunmaktadır. Talepleriniz için Telegram üzerinden
          <strong> @paranoya</strong>’ya ulaşabilirsiniz.
        </p>

        <h2>6. Yatırım Tavsiyesi Reddi</h2>
        <p>
          Platform üzerinden sunulan sinyaller, simülasyonlar ve AI çıktıları
          <strong> yatırım tavsiyesi değildir</strong>. Kripto piyasası yüksek
          risk içerir; sermaye kaybı yaşanabilir. Tüm işlemler kullanıcının
          kendi sorumluluğundadır.
        </p>

        <Link to="/" className="lx-back" data-testid="kvkk-back">← Geri dön</Link>
      </main>
    </div>
  );
}
